import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { getOpenedTaskFiles } from '../../../../../redux/tasks/taskEntities/selectors';

const TaskDetailsFilesTabLabel = ({ taskFiles }) => {
  const intl = useIntl();

  return `${intl.formatMessage({ id: 'FILES', defaultMessage: 'Files' })} ${taskFiles?.length > 0 ? `(${taskFiles?.length})` : ''}`;
};

const mapStateToProps = (state) => ({
  taskFiles: getOpenedTaskFiles(state),
});

export default connect(mapStateToProps)(TaskDetailsFilesTabLabel);
